.wrapper {
  position: relative;
  display: inline-flex;
}

.tooltip {
  position: absolute;
  z-index: var(--z-tooltip);
  width: max-content;
  max-width: 260px;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-md);
  background: var(--color-text);
  color: var(--color-background);
  font-size: var(--font-size-sm);
  line-height: 1.35;
  box-shadow: var(--shadow-md);
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity var(--transition-fast),
    visibility var(--transition-fast);
}

.wrapper:hover > .tooltip,
.wrapper:focus-within > .tooltip {
  opacity: 1;
  visibility: visible;
  transition-delay: 350ms;
}

.bottom {
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
}

.bottom-end {
  top: calc(100% + 6px);
  right: 0;
}

.top {
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
}

.top-end {
  bottom: calc(100% + 6px);
  right: 0;
}

.right {
  left: calc(100% + 6px);
  top: 50%;
  transform: translateY(-50%);
}
